import axios from 'axios';

export const pushNotification = async (
  title = 'Login Success',
  body = 'Welcome to YUCampus',
  data = {},
  user_id
) => {
  try {
    const userData = localStorage.getItem("userData");
    if (!userData) throw new Error("User data not found in localStorage");

    const user = JSON.parse(userData);
    if (!user?.profile_id) throw new Error("Invalid user profile ID");

    const payload = {
      user_id: user_id || user.profile_id,
      title,
      body,
      data
    };

    const res = await axios.post(
      process.env.REACT_APP_NOTIFICATION_API_URL,
      payload
    );
    return res;
  } catch (err) {
    console.error('Push Notification Error:', err.message || err);
    return null;
  }
};
